import { get } from 'lodash';
import moment from 'moment-timezone';
import { AssignedClaim } from 'containers/CourtManagerAssignedClaims/typings';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { MANAGER_ASSIGNMENTS_LABELS } from 'containers/CourtManagerAssignedClaims/constants';

export const formatLossdate = (
  lossDate: string | undefined,
  lossHour: string | undefined,
) => {
  if (!lossDate || !lossHour) return null;

  return `${moment(lossDate).format('DD/MM/YYYY')} ${lossHour}`;
};

export const formatUpdateDate = (updateDate: string | undefined) => {
  if (!updateDate) return null;
  return `${moment(updateDate).format('DD/MM/YYYY')}`;
};

export const getAssignedManagerCode = (
  assignmentManager: any,
  username: string,
) => {
  const assignedManager = assignmentManager.find(
    (el: any) => el.name === username,
  );
  if (assignedManager) return get(assignedManager, 'id');
  return null;
};

export const getAssignedClaims = (assignedClaims: AssignedClaim[]) => {
  const assignedLawyers: any[] = [];
  return assignedClaims.map(assignedClaim => {
    if (
      assignedLawyers.find(
        (el: any) =>
          el.assignedLawyer === assignedClaim.assignedLawyer &&
          el.claimId === assignedClaim.claimId,
      )
    )
      return null;
    assignedLawyers.push({
      assignedLawyer: assignedClaim.assignedLawyer,
      claimId: assignedClaim.claimId,
    });
    return assignedClaim;
  });
};
export const setStepV2 = (currentStep: string) => {
  if (
    featureService.hasFeature(FEATURES.LEGAL_PROCEEDING_STEP) &&
    currentStep
  ) {
    return {
      step: MANAGER_ASSIGNMENTS_LABELS.find(
        (el: any) => el.title === currentStep,
      )?.step,
      procedureType: MANAGER_ASSIGNMENTS_LABELS.find(
        (el: any) => el.title === currentStep,
      )?.procedureType,
    };
  }

  return null;
};
